import { useContext } from "react";
import { useSelector } from "react-redux";

import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

import MovingDottedLoader from "components/Loader/MovingDottedLoader";

import { AutomaticCallProfileContext } from "context-api/AutomaticCallProfileContext";

const DropdownIcon = ({ isEnable }) => {
  if (isEnable) return null;

  return <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />;
};

DropdownIcon.defaultProps = {
  isEnable: false,
};

DropdownIcon.propTypes = {
  isEnable: PropTypes.bool,
};

const DesktopView = ({
  containerClassName,
  activeValueClassName,
  activeProfileValue,
  callProfiles,
  handleActiveCallProfileSelection,
  active,
  isUserProfile,
}) => {
  const { isAutomaticCallProfileEnable } = useContext(
    AutomaticCallProfileContext
  );

  const { isActiveCallProfileUpdating } = useSelector(
    ({ callProfile }) => callProfile
  );

  const addOptionClassName = (name) => {
    if (active?.name !== name) return "";

    return "active-option";
  };

  const typeOfDropdown =
    !isAutomaticCallProfileEnable && !isAutomaticCallProfileEnable
      ? "button"
      : "";
  const userProfileClassName = isUserProfile ? "d-flex" : "d-none d-md-flex";

  return (
    <div
      className={`btn-group custom-dropdown ${containerClassName} ${userProfileClassName}`}
    >
      <div
        className={`btn-sm dropdown-toggle active-profile text-nowrap border-0 position-relative d-flex align-items-center p-2 col-6 ${activeValueClassName}`}
        type={typeOfDropdown}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={isAutomaticCallProfileEnable}
      >
        {activeProfileValue}
        <DropdownIcon
          isEnable={isAutomaticCallProfileEnable || isActiveCallProfileUpdating}
        />
        <MovingDottedLoader show={isActiveCallProfileUpdating} />
      </div>
      <ul
        className={`dropdown-menu dropdown-menu-end custom-dropdown-menu py-2 mt-1 px-2 border-0 ${activeValueClassName}`}
      >
        <div className="item-list">
          {callProfiles.map(
            ({
              icon_json: { brand_name: brandName, icon_name: iconName },
              name,
              id,
              ...rest
            }) => (
              <li key={id}>
                <button
                  className={`dropdown-item  ${addOptionClassName(
                    name
                  )} py-0 px-3 d-flex align-items-center border-0`}
                  onClick={() =>
                    handleActiveCallProfileSelection({
                      icon_json: { brand_name: brandName, icon_name: iconName },
                      name,
                      id,
                      ...rest,
                    })
                  }
                >
                  <FontAwesomeIcon
                    icon={[brandName, iconName]}
                    className="me-3 profile-icon"
                  />
                  <span className="mt-1">{name}</span>
                </button>
              </li>
            )
          )}
        </div>
      </ul>
    </div>
  );
};

DesktopView.defaultProps = {
  containerClassName: "",
  activeValueClassName: "",
  activeProfileValue: null,
  callProfiles: [{}],
  active: {
    name: "",
  },
  isUserProfile: false,
};

DesktopView.propTypes = {
  containerClassName: PropTypes.string,
  activeValueClassName: PropTypes.string,
  activeProfileValue: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.node])
    .isRequired,
  callProfiles: PropTypes.arrayOf(PropTypes.shape({})),
  handleActiveCallProfileSelection: PropTypes.func.isRequired,
  active: PropTypes.shape({
    name: PropTypes.string,
  }),
  isUserProfile: PropTypes.bool,
};

export default DesktopView;
